const mealsPopUpTranslations = {
    ingredients:'المكونات',
    salad:'السلطات',
    actionButton:'اكتمل',
    cancel:'الغاء',
    description:'وصف التحضير',
    disCancel:'الغاء'
}

export default  mealsPopUpTranslations;